export default __webpack_public_path__ + "static/media/img-0425-belarus-half-face.5e252b3d.png";